import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    solicitud: [],
    solicitudes:[],
    solicitudCargar:true,
    solicitudCargarDet:true

  },
  getters: {
    Solicitud(state) {
      return state.solicitud;
    },

    Solicitudes(state){
      return state.solicitudes;
    },

    SolicitudCargar(state){
      return state.solicitudCargar
    },

    SolicitudCargarDet(state){
      return  state.solicitudCargarDet
    }
  },

  mutations: {

    llenarSolicitudes(state ,data){
        state.solicitud = data;
    },

    llenarSolicitudxDet(state , data){
      state.solicitudes = data;
    },


    llenarCargaSolicitud(state,data){
      state.solicitudCargar =  data
    },

    llenarCargarSolicitdDet(state,data){
      state.solicitudCargarDet = data
    }


  },
  actions: {
    async getAttributs({ commit }) {
      const auth = localStorage.getItem("idTrabajdor");

      const response = await axios.get(
        `AccesoSolicitud/ObtenerSolicitud/${auth}`
      );
        console.log('obtener',response.data)
      commit('llenarSolicitudes', response.data)
      commit('llenarCargaSolicitud', false)
    },

   async apiAttributes({commit}) {
      const idTrabajador = localStorage.getItem("idTrabajdor");
    await  axios
        .get(`SolicitudPostulante/ObtenerPostulanteDet/${idTrabajador}`)
        .then((r) => {
           console.log('asass',r.data);
          commit('llenarSolicitudxDet' , r.data)
          commit('llenarCargarSolicitdDet',false)
          

        });
    },
  },
  modules: {},
};
